export interface ValidationResult {
  isValid: boolean;
  message: string;
}

export function validatePassword(password: string): ValidationResult {
  // Vérifier la longueur minimale
  if (password.length < 8) {
    return {
      isValid: false,
      message: 'Le mot de passe doit contenir au moins 8 caractères'
    };
  }

  // Vérifier la présence d'au moins un caractère spécial
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return {
      isValid: false,
      message: 'Le mot de passe doit contenir au moins un caractère spécial'
    };
  }

  // Vérifier la présence d'au moins un caractère en majuscule
  if (!/[A-Z]/.test(password)) {
    return {
      isValid: false,
      message: 'Le mot de passe doit contenir au moins une lettre majuscule'
    };
  }

  // Vérifier la présence d'au moins un caractère en minuscule
  if (!/[a-z]/.test(password)) {
    return {
      isValid: false,
      message: 'Le mot de passe doit contenir au moins une lettre minuscule'
    };
  }

  // Vérifier la présence d'au moins un chiffre
  if (!/[0-9]/.test(password)) {
    return {
      isValid: false,
      message: 'Le mot de passe doit contenir au moins un chiffre'
    };
  }

  return {
    isValid: true,
    message: 'Mot de passe valide'
  };
}

export function validateEmail(email: string): ValidationResult {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  if (!emailRegex.test(email)) {
    return {
      isValid: false,
      message: 'Format d\'email invalide'
    };
  }
  
  return {
    isValid: true,
    message: 'Email valide'
  };
}

export function validatePasswordMatch(password: string, confirmPassword: string): ValidationResult {
  if (password !== confirmPassword) {
    return {
      isValid: false,
      message: 'Les mots de passe ne correspondent pas'
    };
  }
  
  return {
    isValid: true,
    message: 'Les mots de passe correspondent'
  };
}
